import { useCallback, useState } from "react";

import firebase from "firebase/compat/app";

export interface AttachmentInfo {
    filename: string;
    contentType: string;
    size: number;
}

export interface StoredSupportEmail {
    from: string;
    to: string;
    cc: string;
    subject: string;
    text: string;
    html: string;
    attachments: AttachmentInfo[];
}

export const useSupportEmailContent = (supportEmailId: string) => {
    const [content, setContent] = useState<StoredSupportEmail | null | undefined>();

    const fetchContent = useCallback(async () => {
        setContent(undefined);

        try {
            const url = await firebase.app().storage().ref(`application/support-emails/${supportEmailId}`).getDownloadURL();
            const response = await fetch(url);
            const storedSupportEmail = await response.json() as StoredSupportEmail;

            setContent(storedSupportEmail);
        } catch {
            setContent(null);
        }
    }, [supportEmailId]);

    return { content, fetchContent };
};
